import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./context/AuthContext"; // pastikan path sesuai
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'; // << ini harus diatas App.css
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './App.css';
const root = ReactDOM.createRoot(document.getElementById('root'));
const ro = new ResizeObserver(() => {});
ro.observe(document.body);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
